import Switch from "components/switch";

const SwitchField = (props) => {
  const { id, label, desc, mt, mb, defaultChecked, onChange, value } = props;
  return (
    <div className={`flex justify-between ${mt} ${mb} items-center`}>
      <label
        htmlFor={id}
        className="max-w-[80%] hover:cursor-pointer lg:max-w-[65%]"
      >
        {label && <h5 className="text-base font-bold text-navy-700 dark:text-white">
          {label}
        </h5>}
        <p className={`text-base text-gray-600`}>{desc}</p>
      </label>
      <div>
        <Switch name={id} id={id} defaultChecked={defaultChecked} checked={value} onChange={onChange} />
      </div>
    </div>
  );
};

export default SwitchField;
